/* USAGE
Example:
          <Accordion title="Intrebari frecvente"
            tabs={[
            {
              title: "Intrebari frecvente",
              content: "Lorem ipsum"

            }
          ]}
          />

Props:
    "title" - the title of the list - OPTIONAL
    "tabs"- the list of tabs - REQUIRED
    "tab.title" - the tab title - REQUIRED
    "tab.content" - the tab content - REQUIRED
*/

import { ReactNode, useState } from "react";
import { motion } from "framer-motion";
import WIconButton from "../wicon-button/WIconButton";
import clsx from "clsx";
import ReactMarkdown from "react-markdown";

interface Props {
  id?: string;
  title?: string;
  tabs: { title: string; subtitle?: string; content: ReactNode }[];
  isGray?: boolean;
  isOnLanding?: boolean;
  withReactMarkdown?: boolean;
}

export const WAccordion = ({ withReactMarkdown = true, ...props }: Props) => {
  const [isOpen, setIsOpen] = useState(Number(-1));
  return (
    <div className={clsx([props?.isOnLanding && "bg-eklight"])} id={props?.id}>
      <div
        className={clsx([
          props?.isOnLanding &&
            "container flex flex-col gap-5 px-4 mx-auto py-10 lg:max-w-5xl",
        ])}
      >
        {props.title && (
          <div
            className={clsx([
              props?.isOnLanding
                ? "text-3xl font-extrabold lg:text-5xl"
                : "text-lg",
              "mb-5 font-bold",
            ])}
          >
            {props?.title}
          </div>
        )}

        <div className="flex flex-col w-full gap-4">
          {props.tabs.map((tab, index) => (
            <div
              key={index}
              className={clsx([
                props?.isGray ? "bg-eklight" : "bg-white",
                "flex flex-col w-full p-4 transition-all duration-500 rounded-md shadow-sm hover:shadow-md",
              ])}
            >
              <div
                onClick={() =>
                  isOpen === index ? setIsOpen(-1) : setIsOpen(index)
                }
                className="flex items-center justify-between w-full cursor-pointer select-none"
              >
                <div>
                  <div className="font-bold">{tab?.title}</div>
                  {tab?.subtitle && (
                    <div className="text-sm">{tab?.subtitle}</div>
                  )}
                </div>

                <WIconButton
                  type="transparent"
                  icon={isOpen === index ? "minus" : "plus"}
                />
              </div>

              {isOpen === index && (
                <motion.div
                  initial={{ opacity: 0, y: -10, origin: "top" }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="mt-3 text-sm inner-content"
                >
                  {tab?.content && withReactMarkdown ? (
                    <ReactMarkdown
                      // disable es-lint because react-markedown decided its a "good" idea to call the prop "children"
                      // eslint-disable-next-line react/no-children-prop
                      children={tab?.content?.toString()}
                    />
                  ) : (
                    tab?.content
                  )}
                </motion.div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WAccordion;
